module.exports = __webpack_public_path__ + "img/Sweden.8be10e24.svg";